exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.row {\n  margin-left: 0;\n}\n", "", {"version":3,"sources":["/./client/components/loading/LoadingPlaceholder.vue?0250a37f"],"names":[],"mappings":";AAgCA;EACA,eAAA;CACA","file":"LoadingPlaceholder.vue","sourcesContent":["<template lang=\"pug\">\n  content-placeholder(:rows=\"placeholderRows\")\n</template>\n\n<script>\nimport ContentPlaceholder from 'vue-content-placeholder'\n\nexport default {\n  name: 'LoadingPlaceholder',\n\n  components: {\n    ContentPlaceholder\n  },\n\n  data () {\n    return {\n      placeholderRows: [{\n        height: '1.5rem',\n        boxes: [[0, this.generateRandomWidthBetween(40, 100)]]\n      }]\n    }\n  },\n\n  methods: {\n    generateRandomWidthBetween (min, max) {\n      return (Math.floor(Math.random() * (max - min + 1)) + min) + '%'\n    }\n  }\n}\n</script>\n\n<style>\n.row {\n  margin-left: 0;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-b8e2c004","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/loading/LoadingPlaceholder.vue
// module id = 1103
// module chunks = 0